import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Button,
  Paper,
  Divider,
  TextField,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";

import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import TuneIcon from "@mui/icons-material/Tune";
import { NumericFormat } from "react-number-format";
import InputFile from "../GeneralComponents/InputFile";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import SnackbarContext from "../GeneralContext/SnackbarContext";

export default function ParqueDelete() {
  const { pageTitle, setPageTitle } = useContext(GeneralContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [RBDList, setRBDList] = useState([]);
  const [rbdLoading, setRbdLoading] = useState(false);
  const [oficio, setOficio] = useState("");
  const [oficioFecha, setOficioFecha] = useState(dayjs().hour(23).minute(59).second(59));

  const [autoCompleteInput, setAutoCompleteInput] = useState("");
  const [eesData, setEesData] = useState(null);

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [emptyTable, setEmptyTable] = useState(false);

  const [evErrorBaja, setEvErrorBaja] = useState(false);
  const openSnackbar = useContext(SnackbarContext);

  const [bajaFile, setBajaFile] = useState();
  const setFileBaja = (archivo) => {
    setEvErrorBaja(!archivo ? true : false);
    setBajaFile((prevData) => ({
      ...prevData,
      archivo,
    }));
  };

  // Obtiene los datos de EES por RBD
  function getEes() {
    if (autoCompleteInput !== "") {
      axios
        .getEesParque(autoCompleteInput)
        .then((response) => {

          const new_data = {
            ...response.data,
            estado_pago:
            response.data["estado_pago"] === "Facturar"
              ? "Facturando"
              : response.data["estado_pago"] === "Devengar"
              ? "Devengando"
              : "No Facturando",

          servicio_conectividad:
            response.data["servicio_conectividad"]  === "Activo"
              ? "Conectado"
              : response.data["servicio_conectividad"] === "NYA"
              ? "En proceso"
              : "Baja"
          }
          console.log(new_data)

          setEesData(new_data);
          setError(false);
          setErrorMsg("");
        })
        .catch(() => {
          setEesData(null);
          setError(true);
          setErrorMsg("Colegio no encontrado.");
        });
    }
  }

  const handleDeleteRow = (index) => {
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((_, i) => i !== index);
      return updatedRows;
    });
  };

  function getRBD() {
    if (autoCompleteInput !== "") {
      setRbdLoading(true);
      axios
        .getRBD(autoCompleteInput)
        .then((response) => {
          setRBDList(response.data.rbd_list);
          setRbdLoading(false);
          setError(false);
          setErrorMsg("");
          getEes();
        })
        .catch(() => {
          setRBDList([]);
          setRbdLoading(false);
          setError(true);
          setErrorMsg("Colegio no encontrado.");
        });
    }
  }

  useEffect(() => {
    if (autoCompleteInput) {
      getRBD();
    }
  }, [autoCompleteInput]);

  const handleAddRow = () => {
    if (!eesData || error) {
      alert(
        "No se pueden agregar datos. Verifique que el establecimiento exista y que no haya errores."
      );
      return;
    }

    const alreadyExists = rows.some((row) => row.rbd === eesData.rbd);
    setEmptyTable(false);
    if (alreadyExists) {
      return;
    }

    setRows((prevRows) => [
      ...prevRows,
      {
        rbd: eesData.rbd,
        nombre_colegio: eesData.nombre_colegio,
        nombre_operador: eesData.nombre_operador,
        id_zona: eesData.id_zona,
        servicio_conectividad: eesData.servicio_conectividad,
        estado_pago: eesData.estado_pago,
        motivo_baja: "",
      },
    ]);

    setAutoCompleteInput("");
    setEesData(null);
    setError(false);
  };

  const handleMotivoChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].motivo_baja = value;
    setRows(updatedRows);
  };


    function toStructure(arr, fecha) {
  return  arr.map(v => {
      if (v && typeof v === "object") {
        const rbd = String(v.rbd ?? v.RBD ?? v.id ?? v);
        const f = v.fecha_oficio ?? fecha;
        return { rbd, fecha_oficio: f };
      }
      return { rbd: String(v), fecha_oficio: fecha };
    })
  ;
}

  const handleSend = (event) => {
    event.preventDefault();

    if (rows.length === 0) {
      return;
    }

    const updatedFormData = {
      url_oficio: "",
      descripcion:"",
      numero_oficio: oficio,
      fecha_oficio: oficioFecha.hour(23).minute(59).second(59).format("YYYY-MM-DDTHH:mm:ss"), 
      tipo_oficio: "BAJA",
      rbds: toStructure(rows, oficioFecha.hour(23).minute(59).second(59).format("YYYY-MM-DDTHH:mm:ss"))
    };

    setLoading(true);
    if (!bajaFile ) {
      setEvErrorBaja(bajaFile ? true : false);
      setLoading(false);
      return;
    }


    const form = new FormData();

    form.append("prefactura_oficios", JSON.stringify(updatedFormData));


    form.append("file", bajaFile.archivo, "temp.pdf");
    axios
      .putOficiosRBD(form)
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        openSnackbar(
          "Uno mas de los RBD ingresados no estan vinculados a un oficio",
          "error"
        );
      });
  };

  const removeEES = () => {
    setLoading(true);
    alert("Eliminar establecimiento");
    setLoading(false);
  };

  useEffect(() => {
    setPageTitle("Listado de reportes");
  }, [pageTitle, setPageTitle]);

  return (
    <>
      <PageBgBlock>
        <form onSubmit={handleSend} id="parque_remove">
          <Stack alignItems="left" justifyContent="center" spacing={2}>
            <Typography
              variant="h1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
            >
              DAR DE BAJA EES DEL PARQUE
            </Typography>
            <Box
              justifyContent="center"
              sx={{
                maxWidth: "100%",
                margin: "0 auto",
                display: "flex",
              }}
            >
              <Typography
                variant="body"
                align="center"
                sx={{ marginBottom: "3rem", maxWidth: "45rem" }}
              >
                Para <b>dar de baja</b> establecimientos del Parque busque el
                número de RBD, al tener el resultado presione botón “Dar de baja
                estableciemiento del parque”.
              </Typography>
            </Box>
          </Stack>

          <Grid container spacing={2}>
            <Grid size={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  value={autoCompleteInput}
                  onChange={(event, newValue) =>
                    setAutoCompleteInput(newValue || "")
                  }
                  inputValue={autoCompleteInput}
                  onInputChange={(event, newValue) =>
                    setAutoCompleteInput(newValue || "")
                  }
                  disablePortal
                  loading={rbdLoading}
                  loadingText="Cargando..."
                  options={RBDList}
                  autoComplete
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      error={error}
                      helperText={errorMsg}
                      {...params}
                      label="RBD"
                      placeholder="Buscar RBD"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            {params.InputProps.startAdornment}
                            <TuneIcon />
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={3}>
              <PageButtonSimple
                pad=".5rem"
                width="auto"
                onClick={handleAddRow}
                startIcon={<AddCircleOutlineOutlinedIcon />}
                disabled={!autoCompleteInput || rbdLoading}
              >
                Agregar a la lista
              </PageButtonSimple>
            </Grid>
          </Grid>

          <TableContainer component={Paper} sx={{ mb: 2, mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "80px" }}>
                    <IconButton
                      onClick={() => {
                        setRows([]);
                      }}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>RBD</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Operador</TableCell>
                  <TableCell>ID Zona</TableCell>
                  <TableCell>Estado de Pago</TableCell>
                  <TableCell>Estado de Servicio</TableCell>
                  <TableCell>Motivo Baja</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <IconButton onClick={() => handleDeleteRow(index)}>
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                      {row.rbd}
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                      {row.nombre_colegio}
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                      {row.nombre_operador}
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                      {row.id_zona}
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                      {row.estado_pago}
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "middle" }}>
                       <div style={{ display: "flex", alignItems: "center", flexWrap: "no-wrap" }}>
                                <FiberManualRecordIcon
                                  sx={{
                                    fontSize: "0.75rem",
                                    color:
                                      row.servicio_conectividad === "Conectado"
                                        ? "#41AE43"
                                        : row.servicio_conectividad === "En proceso"
                                        ? "#ABABB5"
                                        : "#FB3B3B",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                {row.servicio_conectividad}
                              </div>
                    </TableCell>
                    <TableCell>
                      <TextField
                        required
                        multiline
                        minRows={2}
                        maxRows={4}
                        size="small"
                        sx={{ width: "100%" }}
                        value={row.motivo_baja}
                        onChange={(e) =>
                          handleMotivoChange(index, e.target.value)
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {rows.length === 0 && emptyTable ? (
            <Typography variant="small" color="error" sx={{ flexGrow: 1 }}>
              No hay elementos en la tabla.
            </Typography>
          ) : null}

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid size={6}>
              <FormControl fullWidth variant="outlined">
                <NumericFormat
                  required
                  customInput={TextField}
                  label="N° de Oficio"
                  value={oficio}
                  onValueChange={(newValue) => setOficio(newValue.value)}
                  allowNegative={false}
                  size="small"
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid size={6}>
              <FormControl fullWidth variant="outlined">
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={"es"}
                  localeText={
                    esES.components.MuiLocalizationProvider.defaultProps
                      .localeText
                  }
                >
                  <DateTimePicker
                    label="Fecha oficio"
                    slotProps={{ textField: { size: "small" } }}
                    value={oficioFecha}
                    size="small"
                    sx={{ width: "100%" }}
                    onChange={(newValue) => setOficioFecha(dayjs(newValue))}
                    disableFuture={false}
                    shouldDisableDate={(date) => dayjs(date).isAfter(dayjs(), "day")}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>

            <Grid size={12}>
              <InputFile
                onFileSelect={setFileBaja}
                fileType="pdf"
                placeholder="Oficio de bajas"
                buttonText="Subir archivo"
                sizeBtnGrid={4}
              />
              <Typography
                variant="small"
                align="left"
                sx={{
                  marginBottom: "18px",
                  color: evErrorBaja ? "red" : "#111",
                }}
              >
                {evErrorBaja ? "Debe adjuntar evidencia" : ""}
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ margin: "auto", marginTop: "2rem" }}>
            <PageButtonSimple
              form="parque_remove"
              disabled={rows.length === 0}
              width="350px"
              startIcon={<RemoveCircleOutlineOutlinedIcon />}
              loading={loading}
              style="warning"
              bgColor={rows.length === 0 ? "" : "rgba(255, 71, 49, 0.1)"}
            >
              Dar de baja establecimiento del parque
            </PageButtonSimple>
          </Box>
        </form>
      </PageBgBlock>
    </>
  );
}
